import {
  ENABLE_LEGACY_SHELL_ZOOM_COMPENSATION,
  ZOOM_CONFIG,
} from './ZoomContext.constants';

type ZoomDirection = 'in' | 'out';

export const clampZoom = (level: number): number => Math.max(ZOOM_CONFIG.MIN, Math.min(ZOOM_CONFIG.MAX, level));

export const roundZoomLevel = (level: number): number => Math.round(level * 100) / 100;

export const getNextZoomLevel = (zoomLevel: number, direction: ZoomDirection): number => {
  const step = direction === 'in' ? ZOOM_CONFIG.STEP : -ZOOM_CONFIG.STEP;

  return clampZoom(roundZoomLevel(zoomLevel + step));
};

// Keep the bridge centralized so the compensation can be disabled from ZoomContext.constants.
export const getLegacyShellZoomCompensation = (): number => (
  ENABLE_LEGACY_SHELL_ZOOM_COMPENSATION ? roundZoomLevel(1 / ZOOM_CONFIG.DEFAULT) : 1
);

export const loadZoomFromStorage = (): number => {
  try {
    const saved = localStorage.getItem(ZOOM_CONFIG.STORAGE_KEY);
    if (saved) {
      const parsed = parseFloat(saved);
      if (parsed >= ZOOM_CONFIG.MIN && parsed <= ZOOM_CONFIG.MAX) {
        return parsed;
      }
    }
  } catch (error) {
    // localStorage can be unavailable in private browsing or non-browser render contexts.
    // eslint-disable-next-line no-console
    console.warn('Failed to load zoom level from localStorage:', error);
  }
  return ZOOM_CONFIG.DEFAULT;
};

export const saveZoomToStorage = (level: number): void => {
  try {
    localStorage.setItem(ZOOM_CONFIG.STORAGE_KEY, level.toString());
  } catch (error) {
    // localStorage can be unavailable in private browsing or non-browser render contexts.
    // eslint-disable-next-line no-console
    console.warn('Failed to save zoom data to localStorage:', error);
  }
};
